export interface ConversionCleanupReportModel {
    id: string;
    conversionName: string;
    conversionType: string;
    runType: string;
    createdByName: string;
    createdByEmail: string;
    goLiveDate: string | null;
    createdDate: string;
    retentionCutoffDate: string;
    isEligibleForDeletion: boolean;
    doNotArchive: boolean;
    deletionException: string | null;
}

export interface ConversionCleanupReportResponse {
    retentionDays: number;
    records: ConversionCleanupReportModel[];
}

export async function getCleanupReport(): Promise<ConversionCleanupReportResponse> {
    const response = await fetch('/api/v1/conversions/cleanup/report', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    });
    if (!response.ok) {
        const error: any = new Error(`Failed to fetch cleanup report: ${response.status} ${response.statusText}`);
        error.status = response.status;
        throw error;
    }
    return response.json() as Promise<ConversionCleanupReportResponse>;
}

